export enum editorStates {
  Read,
  Edit,
  Confirm
}

export enum permissionFlags {
  Include,
  Exclude
}

export enum favoriteFlags
{
    System = 1,
    Private = 2,
    Public = 4,
    All = System | Private | Public
}

export enum siteModes
{
  tenant = 1,
  admin = 2,
  signup = 3,
}

export enum functionFlags
{
  /**標準モード */  
  ProjectItem = 1,
  /**在庫管理機能 */    
  Stock = 2,
  /**運用管理機能 */      
  Operation = 4,
}
export enum licenseFlags
{
  /**外貨対応 */  
  currency = 1,
  /**輸入 */    
  import = 2,
  /**輸出 */      
  export = 4,
  /**プライム */
  prime = 8,  
}
export enum optionFlags
{
  not_specified = 0,
  support_phone = 1,
  powerbi = 2
}
export enum enviromentFlags
{
  /**本番 */
  production = 1,
  /**ステージング */
  staging = 2,
  /**開発 */
  develop = 3,
}

export enum dateFlags
{
  default = 0,
  today = 1,
  yesterday = 2,
  current_week_begin = 3,
  current_week_end = 4,    
  previous_week_begin = 5,
  previous_week_end = 6,        
  current_month_begin = 7,
  current_month_end = 8,
  previous_month_begin = 9,
  previous_month_end = 10,  
  current_year_begin =11,
  current_year_end = 12,
  previous_year_begin = 13,
  previous_year_end = 14,
  one_week_after = 15,
  two_week_after = 16,
  three_week_after = 17,  
}

export enum paymentAgents
{
  default = 0,
  payJp = 1,
}

export enum TenantVersions
{
    Default = 0,
    Version_240830 = 1
}